import React, { ReactNode } from "react";
import Typography from "@vahak/core-ui/dist/components/Typography";
import Flex from "@vahak/core-ui/dist/layout/Flex";

// constants
import COLORS from "@vahak/core-ui/dist/constants/colors";

interface TextLabelAndValuePropsType {
    label: string;
    value: ReactNode;
    boldWeight?: boolean;
    preWrapValue?: boolean;
}

const TextLabelAndValue = ({ label, value, boldWeight = true, preWrapValue = false }: TextLabelAndValuePropsType) => {
    return (
        <Flex gap={5} alignItems="center">
            <Typography color={COLORS.GREY_1000} size="s" lineHeight={"24px"} weight="medium">
                {label}
            </Typography>
            :{" "}
            <Flex flex={1} alignItems="center">
                <Typography weight={boldWeight ? "bold" : "regular"} preWrap={preWrapValue}>
                    {value}
                </Typography>
            </Flex>
        </Flex>
    );
};

export default TextLabelAndValue;
